import { NgOptimizedImage } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AngularMyDatePickerModule } from "angular-mydatepicker";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { StorageModule } from "src/libs/storage/src";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BuyClientNumberModalComponent } from "./components/client/buy-client-number-modal/buy-client-number-modal.component";
import { ClientInfoFormComponent } from "./components/client/client-info-form/client-info-form.component";
import { EditClientInfoModalComponent } from "./components/client/edit-client-info-modal/edit-client-info-modal.component";
import { ClientInfoSectionItemComponent } from "./components/client/client-info-section-item/client-info-section-item.component";
import { ClientInfoSectionComponent } from "./components/client/client-info-section/client-info-section.component";
import { ClientNumbersFormComponent } from "./components/client/client-numbers-form/client-numbers-form.component";
import { ExpiredSubscriptionErrorModalComponent } from "./components/client/expired-subscription-error-modal/expired-subscription-error-modal.component";
import { MissingSubscriptionErrorModalComponent } from "./components/client/missing-subscription-error-modal/missing-subscription-error-modal.component";
import { ContactFormComponent } from "./components/contact/contact-form/contact-form.component";
import { ContactListComponent } from "./components/contact/contact-list/contact-list.component";
import { CreateContactModalComponent } from "./components/contact/create-contact-modal/create-contact-modal.component";
import { DeleteContactModalComponent } from "./components/contact/delete-contact-modal/delete-contact-modal.component";
import { EditContactModalComponent } from "./components/contact/edit-contact-modal/edit-contact-modal.component";
import { SearchContactModalComponent } from "./components/contact/search-contact-modal/search-contact-modal.component";
import { SelectContactModalComponent } from "./components/contact/select-contact-modal/select-contact-modal.component";
import { CoverPageFormComponent } from "./components/cover-page/cover-page-form/cover-page-form.component";
import { CoverPagesListComponent } from "./components/cover-page/cover-pages-list/cover-pages-list.component";
import { CreateCoverPageModalComponent } from "./components/cover-page/create-cover-page-modal/create-cover-page-modal.component";
import { DeleteCoverPageModalComponent } from "./components/cover-page/delete-cover-page-modal/delete-cover-page-modal.component";
import { EditCoverPageModalComponent } from "./components/cover-page/edit-cover-page-modal/edit-cover-page-modal.component";
import { AttachmentComponent } from "./components/fax/attachment/attachment.component";
import { BriefFaxTableComponent } from "./components/fax/brief-fax-table/brief-fax-table.component";
import { CreateFaxRuleModalComponent } from "./components/fax/create-fax-rule-modal/create-fax-rule-modal.component";
import { DeleteFaxFolderModalComponent } from "./components/fax/delete-fax-folder-modal/delete-fax-folder-modal.component";
import { DeleteFaxRuleModalComponent } from "./components/fax/delete-fax-rule-modal/delete-fax-rule-modal.component";
import { DeleteFaxModalComponent } from "./components/fax/delete-fax-modal/delete-fax-modal.component";
import { EfaxWizardComponent } from "./components/fax/efax-wizard/efax-wizard.component";
import { FaxFilterListFormComponent } from "./components/fax/fax-filter-list-form/fax-filter-list-form.component";
import { FaxFilterListWrapperComponent } from "./components/fax/fax-filter-list-wrapper/fax-filter-list-wrapper.component";
import { FaxFolderListComponent } from "./components/fax/fax-folder-list/fax-folder-list.component";
import { FaxInfoModalComponent } from "./components/fax/fax-info-modal/fax-info-modal.component";
import { FaxPdfViewerComponent } from "./components/fax/fax-pdf-viewer/fax-pdf-viewer.component";
import { FaxRecipientInfoFormComponent } from "./components/fax/fax-recipient-info-form/fax-recipient-info-form.component";
import { FaxRuleListComponent } from "./components/fax/fax-rule-list/fax-rule-list.component";
import { FaxZoomModalComponent } from "./components/fax/fax-zoom-modal/fax-zoom-modal.component";
import { PreviewFaxComponent } from "./components/fax/preview-fax/preview-fax.component";
import { ResendFaxModalComponent } from "./components/fax/resend-fax-modal/resend-fax-modal.component";
import { RetrySendFaxComponent } from "./components/fax/retry-send-fax/retry-send-fax.component";
import { SendFaxFinishComponent } from "./components/fax/send-fax-finish/send-fax-finish.component";
import { NotificationBarComponent } from "./components/notification-bar/notification-bar.component";
import { ChangeSubscriptionModalComponent } from "./components/subscription/change-subscription-modal/change-subscription-modal.component";
import { TrialSubscriptionModalComponent } from "./components/subscription/trial-subscription-modal/trial-subscription-modal.component";
import { SearchTelnyxNumberFormComponent } from "./components/telnyx/search-telnyx-number-form/search-telnyx-number-form.component";
import { ToastComponent } from "./components/toast/toast.component";
import { CalendarComponent } from "./components/ui-kit/controls/calendar/calendar.component";
import { DropdownComponent } from "./components/ui-kit/controls/dropdown/dropdown.component";
import { SelectComponent } from "./components/ui-kit/controls/select/select.component";
import { SwitcherComponent } from "./components/ui-kit/controls/switcher/switcher.component";
import { HeaderComponent } from "./components/ui-kit/layout/header/header.component";
import { InAppPageComponent } from "./components/ui-kit/layout/in-app-page/in-app-page.component";
import { LoaderComponent } from "./components/ui-kit/layout/loader/loader.component";
import { SidebarComponent } from "./components/ui-kit/layout/sidebar/sidebar.component";
import { TabsComponent } from "./components/ui-kit/layout/tabs/tabs.component";
import { BaseModalComponent } from "./components/ui-kit/modals/base-modal/base-modal.component";
import { ErrorModalComponent } from "./components/ui-kit/modals/error-modal/error-modal.component";
import { SuccessModalComponent } from "./components/ui-kit/modals/success-modal/success-modal.component";
import { StepperComponent } from "./components/ui-kit/stepper/stepper.component";
import { ClickOutsideDirective } from "./directives/click-outside.directive";
import { InvalidControlScrollDirective } from "./directives/invalid-control-scroll.directive";
import { RefDirective } from "./directives/ref.directive";
import { httpInterceptorProviders } from "./http-interceptors";
import { FilterDescPipe } from "./pipes/filter-desc.pipe";
import { FilterOrdersPipe } from "./pipes/filter-orders.pipe";
import { ToFixedPipe } from "./pipes/to-fixed.pipe";
import { TruncatePipe } from "./pipes/truncate.pipe";
import { AuthComponent } from "./views/auth/auth.component";
import { PasswordResetComponent } from "./views/auth/password-reset/password-reset.component";
import { RestorePasswordComponent } from "./views/auth/restore-password/restore-password.component";
import { SignUpComponent } from "./views/auth/sign-up/sign-up.component";
import { VerifyEmailComponent } from "./views/auth/verify-email/verify-email.component";
import { DashboardComponent } from "./views/in-app/dashboard/dashboard.component";
import { FaxComponent } from "./views/in-app/faxes/fax/fax.component";
import { FaxesComponent } from "./views/in-app/faxes/faxes.component";
import { SendComponent } from "./views/in-app/faxes/send/send.component";
import { InAppComponent } from "./views/in-app/in-app.component";
import { PhoneBookComponent } from "./views/in-app/phone-book/phone-book.component";
import { FiltersComponent } from "./views/in-app/settings/filters/filters.component";
import { NotificationsComponent } from "./views/in-app/settings/notifications/notifications.component";
import { PasswordComponent } from "./views/in-app/settings/password/password.component";
import { ProfileComponent } from "./views/in-app/settings/profile/profile.component";
import { SettingsComponent } from "./views/in-app/settings/settings.component";
import { UsageSummaryComponent } from "./views/in-app/settings/usage-summary/usage-summary.component";
import { SubscriptionComponent } from "./views/in-app/subscription/subscription.component";
import { CallingPolicyComponent } from "./views/legal/calling-policy/calling-policy.component";
import { CancellationPolicyComponent } from "./views/legal/cancellation-policy/cancellation-policy.component";
import { LegalComponent } from "./views/legal/legal.component";
import { UsePolicyComponent } from "./views/legal/use-policy/use-policy.component";
import { VoipServiceComponent } from "./views/legal/voip-service/voip-service.component";
import { NotFoundComponent } from "./views/not-found/not-found.component";
import { PrivacyComponent } from "./views/privacy/privacy.component";
import { GuidesComponent } from "./views/resources/guides/guides.component";
import { ResourcesComponent } from "./views/resources/resources.component";
import { FaxPagesPreviewsComponent } from "./components/fax/fax-pages-previews/fax-pages-previews.component";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SwitcherComponent,
    DropdownComponent,
    NotFoundComponent,
    SelectComponent,
    PrivacyComponent,
    LegalComponent,
    FilterDescPipe,
    LoaderComponent,
    ToastComponent,
    FilterOrdersPipe,
    CallingPolicyComponent,
    CancellationPolicyComponent,
    UsePolicyComponent,
    VoipServiceComponent,
    ResourcesComponent,
    GuidesComponent,
    ToFixedPipe,
    TruncatePipe,
    RefDirective,
    ClickOutsideDirective,
    NotificationBarComponent,
    InvalidControlScrollDirective,
    // New components after refactoring 25.02.2026
    AuthComponent,
    RestorePasswordComponent,
    PasswordResetComponent,
    SignUpComponent,
    VerifyEmailComponent,
    DashboardComponent,
    SettingsComponent,
    ProfileComponent,
    FiltersComponent,
    NotificationsComponent,
    TabsComponent,
    CoverPagesListComponent,
    SuccessModalComponent,
    ErrorModalComponent,
    CreateCoverPageModalComponent,
    EditCoverPageModalComponent,
    DeleteCoverPageModalComponent,
    SearchContactModalComponent,
    BaseModalComponent,
    CoverPageFormComponent,
    ClientInfoFormComponent,
    EditClientInfoModalComponent,
    ClientInfoSectionComponent,
    ClientInfoSectionItemComponent,
    SidebarComponent,
    InAppComponent,
    BriefFaxTableComponent,
    InAppPageComponent,
    FaxComponent,
    FaxPdfViewerComponent,
    FaxInfoModalComponent,
    FaxZoomModalComponent,
    ClientNumbersFormComponent,
    BuyClientNumberModalComponent,
    SearchTelnyxNumberFormComponent,
    FaxFilterListWrapperComponent,
    FaxFolderListComponent,
    FaxFilterListFormComponent,
    FaxRuleListComponent,
    DeleteFaxFolderModalComponent,
    CreateFaxRuleModalComponent,
    DeleteFaxRuleModalComponent,
    DeleteFaxModalComponent,
    ResendFaxModalComponent,
    PasswordComponent,
    UsageSummaryComponent,
    SendComponent,
    EfaxWizardComponent,
    FaxRecipientInfoFormComponent,
    AttachmentComponent,
    FaxPagesPreviewsComponent,
    PreviewFaxComponent,
    SendFaxFinishComponent,
    SelectContactModalComponent,
    FaxesComponent,
    CalendarComponent,
    PhoneBookComponent,
    CreateContactModalComponent,
    EditContactModalComponent,
    ContactFormComponent,
    ContactListComponent,
    DeleteContactModalComponent,
    RetrySendFaxComponent,
    ExpiredSubscriptionErrorModalComponent,
    MissingSubscriptionErrorModalComponent,
    SubscriptionComponent,
    TrialSubscriptionModalComponent,
    ChangeSubscriptionModalComponent,
    StepperComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    AppRoutingModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    StorageModule.forRoot(),
    PdfViewerModule,
    AngularMyDatePickerModule,
  ],
  providers: [
    // {
    //     provide: HTTP_INTERCEPTORS,
    //     useClass: HttpRequestInterceptor,
    //     multi: true,
    // },
    httpInterceptorProviders,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
